// src/common/store/slices/bonusSlice.ts
import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { BonusTransaction } from '../../common/types/types'

interface BonusData {
  balance: number
  totalSpent: number
  bonusPercent: number
  level?: string
}

interface BonusState {
  data: BonusData
  history: BonusTransaction[]
}

const initialState: BonusState = {
  data: {
    balance: 0,
    totalSpent: 0,
    bonusPercent: 0,
    level: undefined,
  },
  history: [],
}

export const bonusSlice = createSlice({
  name: 'bonus',
  initialState,
  reducers: {
    setBonusData: (state, action: PayloadAction<BonusData>) => {
      state.data = action.payload
    },
    setBonusHistory: (state, action: PayloadAction<BonusTransaction[]>) => {
      state.history = action.payload
    },
    clearBonus: (state) => {
      state.data = initialState.data
      state.history = []
    },
  },
})

export const { setBonusData, setBonusHistory, clearBonus } = bonusSlice.actions

// Селекторы
export const selectBonusState = (state: RootState) => state.bonus

export const selectBonusBalance = createSelector([selectBonusState], (bonus) => bonus.data.balance)

export const selectBonusTotalSpent = createSelector(
  [selectBonusState],
  (bonus) => bonus.data.totalSpent,
)

export const selectBonusPercent = createSelector(
  [selectBonusState],
  (bonus) => bonus.data.bonusPercent,
)

export const selectBonusLevel = createSelector([selectBonusState], (bonus) => bonus.data.level)

export const selectBonusHistory = createSelector([selectBonusState], (bonus) => bonus.history)

export default bonusSlice.reducer
